<template>
  <article class="layout-section">
    <div class="rte" v-html="wp.content" />
  </article>
</template>

<script>
export default {
  name: 'PolicyIndex',
  inject: ['wp']
}
</script>
